import { render, staticRenderFns } from "./sendCoupon.vue?vue&type=template&id=ef4d1196&scoped=true"
import script from "./sendCoupon.vue?vue&type=script&lang=js"
export * from "./sendCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4d1196",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef4d1196')) {
      api.createRecord('ef4d1196', component.options)
    } else {
      api.reload('ef4d1196', component.options)
    }
    module.hot.accept("./sendCoupon.vue?vue&type=template&id=ef4d1196&scoped=true", function () {
      api.rerender('ef4d1196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/list/sendCoupon.vue"
export default component.exports